import { render, staticRenderFns } from "./HeadlineAlert.vue?vue&type=template&id=6df00c48&scoped=true&"
import script from "./HeadlineAlert.vue?vue&type=script&lang=ts&"
export * from "./HeadlineAlert.vue?vue&type=script&lang=ts&"
import style0 from "./HeadlineAlert.vue?vue&type=style&index=0&id=6df00c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df00c48",
  null
  
)

export default component.exports